import styled from 'styled-components';
import { navBarValues } from '../Navbar/navbar.styles';

export const LayoutWrapperContainer = styled.div`
  .main-wrapper {
    padding-top: ${navBarValues.height};
  }

  .spiner-container {
    display: flex;
    height: 100vh;
    width: 100vw;
    background-color: white;
  }
`;
